import { lazy } from 'react';

export const LazyMonitoringSection = lazy(() => import('../MonitoringSection'));